module.exports = __webpack_public_path__ + "static/media/hoopsAI_Icon_Color_Expression1.52ba7528.svg";